






































import { Component, Vue } from "vue-property-decorator";
import {
  ServiceTaskType,
  getServiceTaskTypes,
  deleteServiceTaskType
} from "@/servicetask/api/service-tasks-api";
import VToolbar from "../../../ui/common/components/VToolbar.vue";

@Component({
  components: {
    VToolbar
  }
})
export default class ServiceTasksListPage extends Vue {
  taskTypes: ServiceTaskType[] = [];
  fields = [
    {
      key: "id",
      label: "ID"
    },
    {
      key: "name",
      label: "工程表種別名"
    },
    { key: "actions", label: " " }
  ];

  newTaskType() {
    this.$router.push({ path: "/admin/service-tasks/new" });
  }

  protected created() {
    this.initServiceTaskTypes();
  }

  private async initServiceTaskTypes() {
    this.taskTypes = await getServiceTaskTypes();
  }

  async destroy(serviceTaskId: string) {
    if (!confirm("本当に削除してもよろしいですか？")) return;
    await deleteServiceTaskType(serviceTaskId);
    this.initServiceTaskTypes();
  }
}
